/**
 * Source unique de l'URL de base du backend (Story 8.2).
 * - Dev : VITE_API_BASE vide -> '/api' (proxy Vite).
 * - Prod : VITE_API_BASE=https://api.<domaine>/api (cross-domain).
 */
export function resolveApiBase(raw?: string): string {
  let base = raw || '/api'
  if (!base || base === '/') base = '/api'
  // Remove trailing slash
  if (base.length > 1 && base.endsWith('/')) base = base.slice(0, -1)
  // If absolute backend root (http...) but missing /api, append it
  if (/^https?:\/\//i.test(base) && !base.toLowerCase().endsWith('/api')) {
    base = `${base}/api`
  }
  return base
}

/** '' pour une base relative (proxy Vite), origine de l'URL pour une base absolue. */
export function resolveBackendOrigin(apiBase: string): string {
  if (!/^https?:\/\//i.test(apiBase)) return ''
  try {
    return new URL(apiBase).origin
  } catch {
    console.warn('[apiBase] URL de base invalide, repli sur une base relative:', apiBase)
    return ''
  }
}

export const API_BASE = resolveApiBase(import.meta.env.VITE_API_BASE as string | undefined)
export const BACKEND_ORIGIN = resolveBackendOrigin(API_BASE)
